import { DetailsView, FileManagerComponent, NavigationPane, Toolbar, Inject } from '@syncfusion/ej2-react-filemanager';
import * as React from 'react';
import { getValue, registerLicense, select } from '@syncfusion/ej2-base';
import { TooltipComponent, TooltipEventArgs } from '@syncfusion/ej2-react-popups';
import { BASE_URL } from '../../api/endpoint';
import { Toast } from 'primereact/toast';
import { CustomMessage } from '../../const/Spinner';
import { enqueueSnackbar } from 'notistack';

// registerLicense("Ngo9BigBOggjHTQxAR8/V1NMaF1cXmhKYVVpR2Nbek5xflBFalhUVAciSV9jS3tTdEdkWX5bc3BQQWRUUA==");//test
registerLicense("Ngo9BigBOggjHTQxAR8/V1NMaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWX1cd3RcRmJfVkxzVkE=");

const FileManagerComponentIndex = () => {
    let fileObj: FileManagerComponent;
    let tooltipObj: TooltipComponent;
    // let hostUrl: string = "https://ej2-aspcore-service.azurewebsites.net/api/"; 

    let hostUrl: string = BASE_URL;

    function onTooltipBeforeRender(args: TooltipEventArgs): void {
      const buttonId: string = select('button', args.target).id;
      let description: string = '';
        switch (buttonId) {
            case fileObj.element.id + '_tb_newfolder':
                description = 'Create a new folder';
                break;
            case fileObj.element.id + '_tb_upload':
                description = 'Upload new files';
                break;
            case fileObj.element.id + '_tb_cut':
                description = 'Cut files and folders from the current location';
                break;
            case fileObj.element.id + '_tb_copy':
                description = 'Copy files and folders from the current location';
                break;
            case fileObj.element.id + '_tb_paste':
                description = 'Paste files and folders in the current location';
                break;
            case fileObj.element.id + '_tb_delete':
                description = 'Delete selected files and folders';
                break;
            case fileObj.element.id + '_tb_download':
                description = 'Download selected files and folders';
                break;
            case fileObj.element.id + '_tb_rename':
                description = 'Rename selected file or folder';
                break;
            case fileObj.element.id + '_tb_sortby':
                description = 'Change the file sorting order';
                break;
            case fileObj.element.id + '_tb_refresh':
                description = 'Refresh the current location';
                break;
            case fileObj.element.id + '_tb_selection':
                description = 'Following items are currently selected:';
                for (let i: number = 0; i < fileObj.selectedItems.length; i++) {
                    description = description + '</br>' + fileObj.selectedItems[i];
                }
            break;
            case fileObj.element.id + '_tb_view':
                description = 'Switch the layout view';
                break;
            case fileObj.element.id + '_tb_details':
                description = 'Get the details of the seletced items';
                break;
            default:
                description = '';
                break;
        }
      tooltipObj.content = args.target.getAttribute('title') + '</br>' + description;
    }
    function fileLoad(args: any): void {
      const target: Element = args.element;
      if (args.module==='DetailsView') {
          const element: Element = select('[title]', args.element);
          const title: string = getValue('name', args.fileDetails) +
              '\n' + getValue('dateModified', args.fileDetails);
          element.setAttribute('title', title);
      } else if (args.module==='LargeIconsView') {
          const title: string = getValue('name', args.fileDetails) +
              '\n' + getValue('dateModified', args.fileDetails);
          target.setAttribute('title', title);
      }
    }

    const onFailure = (args: any) => {
    
        if (args?.error) {
            let errorMessage = "An error occurred";
            CustomMessage(args?.error || errorMessage, 'error',enqueueSnackbar);
        }
    };    

    return (
        <TooltipComponent id="template-tootip" ref={ (s: TooltipComponent | null) => { if (s) tooltipObj = s; }} target="#file_toolbar [title]" beforeRender={onTooltipBeforeRender} >
            <div className="filemanager-container">
            {/* File Manager element */}
            <FileManagerComponent ref={ (s: FileManagerComponent | null) => { if (s) fileObj = s; }} id="file" height="450px"
                ajaxSettings = {{
                    downloadUrl: hostUrl +'FileManager/Download',
                    getImageUrl: hostUrl +'FileManager/GetImage',
                    uploadUrl: hostUrl +'FileManager/Upload',
                    url: hostUrl + 'FileManager/FileOperations'      
                }} 
                fileLoad={fileLoad}
                failure={onFailure}
                // view="Details"
            >
                <Inject services={[ NavigationPane, DetailsView, Toolbar]} />
            </FileManagerComponent>
            </div>
        </TooltipComponent>
    );
};

export default FileManagerComponentIndex;
